// Light / dark mode. The `dark` class on <html> switches every colour (see
// tailwind.theme.js). The choice is kept with the account (User.theme on the
// backend) and, for the sign-in page and the first paint before the profile
// loads, in this browser too. public/index.html applies the browser's copy
// before React starts so a dark page never flashes white.

export const THEME_KEY = 'kw-theme';
const META_COLOURS = { light: '#ffffff', dark: '#161b22' };

export const normalizeTheme = (theme) => (theme === 'dark' ? 'dark' : 'light');

export function readSavedTheme() {
  try {
    return normalizeTheme(localStorage.getItem(THEME_KEY));
  } catch {
    return 'light';
  }
}

export function applyTheme(theme) {
  const t = normalizeTheme(theme);
  const root = document.documentElement;
  root.classList.toggle('dark', t === 'dark');
  // Native controls (scrollbars, date pickers, select menus) follow along.
  root.style.colorScheme = t;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', META_COLOURS[t]);
  try {
    localStorage.setItem(THEME_KEY, t);
  } catch {
    // Private mode / storage full — the account still has it.
  }
  return t;
}
